
import { AccountController } from "@/app/ui/controllers/AccountController";
import { Vue } from "vue-class-component";
import generateSummaryPdf from "@/app/ui/views/hub-to-hub/modules/print-summary/index";
import generateManifestPdf from "@/app/ui/views/hub-to-hub/modules/print-manifest/index";

export default class Print extends Vue {
  // get profile account
  get dataProfile() {
    return AccountController.accountData;
  }

  async printSummary(data: any, hmNo: string, logo: string, language: string) {
    generateSummaryPdf(`Inhub Manifest - ${hmNo}`, data, logo);
  }
  async printSummaryOutHub(data: any, hmNo: string, logo: string, language: string) {
    generateSummaryPdf(`Outhub Manifest - ${hmNo}`, data, logo);
  }
  async printManifest(hmNo: string, data: any, logo: string, outhub: boolean) {
    generateManifestPdf(hmNo, data, logo, outhub);
  }
  async printManifestOutHub(hmNo: string, data: any, logo: string, outhub: boolean) {
    generateManifestPdf(hmNo, data, logo, outhub);
  }

  // role account user
  get roleAccount() {
    return (
      (this.dataProfile.account_type === "partner"
        ? this.dataProfile.account_type_detail.type
        : this.dataProfile.account_type) || "internal"
    );
  }
}
